export const IDEAS_COUNT_LIMIT = 2000;
